import { render, staticRenderFns } from "./RecurringPaymentEditor.vue?vue&type=template&id=2a45133e&scoped=true"
import script from "./RecurringPaymentEditor.vue?vue&type=script&lang=js"
export * from "./RecurringPaymentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45133e",
  null
  
)

export default component.exports